module.exports = __webpack_public_path__ + "dcdbefc641a22794aee3ee98d6c84424.png";